import { render, staticRenderFns } from "./other_customer_orders.vue?vue&type=template&id=48f0fe06&scoped=true&"
import script from "./other_customer_orders.vue?vue&type=script&lang=js&"
export * from "./other_customer_orders.vue?vue&type=script&lang=js&"
import style0 from "./other_customer_orders.vue?vue&type=style&index=0&id=48f0fe06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f0fe06",
  null
  
)

export default component.exports